/* rxlib - ButtonLink v2.0.0 */

import { ButtonClassStyle } from '../button';

export interface ButtonLinkProps {
    link: string;
    texto: string;
    className?: string;
    fontAwesomeIcon?: string;
    abrirNovaJanela?: boolean;
    classStyle: ButtonClassStyle;
}

export default function ButtonLink({
    link,
    texto,
    className,
    classStyle,
    abrirNovaJanela,
    fontAwesomeIcon,
}: ButtonLinkProps) {
    let classNameButton: string = 'btn btn-block rxlib-btn ' + classStyle;
    if ((className) && (className !== '')) {
        classNameButton = className + ' ' + classNameButton;
    }

    function configurarLink(): React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
        let linkProps: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> = {
            href: link,
            className: classNameButton,
        };

        if (abrirNovaJanela) {
            linkProps.target = '_blank';
            linkProps.rel = 'noopener noreferrer';
        }

        return linkProps;
    }

    return (
        <a {...configurarLink()}>
            {
                (fontAwesomeIcon)
                    ? <i className={fontAwesomeIcon}></i>
                    : texto
            }
        </a>
    );
}